export const nestedQueryFormatter = (
  name: string,
  attributes: any,
  skipEmptyOrZero: boolean = true
) => {
  const params: { [key: string]: any } = {}

  if (!attributes) {
    return params
  }
  for (const [key, value] of Object.entries(attributes)) {
    if (value || !skipEmptyOrZero) {
      params[`${name}[${key}]`] = value
    }
  }
  return params
}

export const searchToObject = () => {
  const pairs = window.location.search.substring(1).split('&')
  const obj: Record<string, any> = {}
  let pair

  for (const i in pairs) {
    const entry = pairs[i]
    if (!entry) {
      continue
    }

    pair = entry.split('=')
    const key = pair[0]
    if (key === undefined) {
      continue
    }

    obj[decodeURIComponent(key)] = decodeURIComponent(pair[1] ?? '')
  }

  return obj
}
